// @ts-nocheck
import {
    chain,
    LoadRealTimePricingAndInventory as baseLoadRealTimePricingAndInventory,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadRealTimePricingAndInventory = createChainHandler(
    "LoadRealTimePricingAndInventory",
    chain,
    async props => {
        if (props.product?.isVariantParent) {
            props.pricingLoaded = props.inventoryLoaded = true;
            return;
        }

        await baseLoadRealTimePricingAndInventory(props);
    },
);

replaceInChain(chain, baseLoadRealTimePricingAndInventory, LoadRealTimePricingAndInventory);
